import { registerComponent, createMessage } from "helpers";

const KLAVIYO_COMPANY_ID = "UA6maD";
const KLAVIYO_LIST_ID = "XUdR5C";

registerComponent(
  "back-in-stock-form",
  class BackInStockForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector("[data-back-in-stock-form]");

      this.form.addEventListener("submit", this.handleSubmit.bind(this));

      this.message = this.querySelector("[data-response-message]");
      this.messageContainer = this.querySelector(
        ".back-in-stock-form__response-container",
      );
    }

    errorMessage() {
      createMessage(WYATT.t.backInStock.error, {
        type: "error",
        appendPoint: "[data-response-message]",
      });
    }

    successMessage() {
      createMessage(WYATT.t.backInStock.success, {
        type: "success",
        appendPoint: "[data-response-message]",
      });
    }
    handleSubmit(event) {
      event.preventDefault();

      const email = this.querySelector("[data-user-email]").value;
      const { variantId } = this.dataset;
      const subscription = this.querySelector("[data-user-subscription]");

      const backInStockUrl = `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${KLAVIYO_COMPANY_ID}`;
      const subscriptionUrl = `https://a.klaviyo.com/client/subscriptions/?company_id=${KLAVIYO_COMPANY_ID}`;

      const fetchOptions = (data) => ({
        method: "POST",
        headers: {
          Accept: "application/vnd.api+json",
          "Content-Type": "application/vnd.api+json",
          Revision: "2024-10-15",
        },
        body: JSON.stringify(data),
      });

      const backInStockData = {
        data: {
          type: "back-in-stock-subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: { email },
              },
            },
            channels: ["EMAIL"],
          },
          relationships: {
            variant: {
              data: {
                type: "catalog-variant",
                id: `$shopify:::$default:::${variantId}`,
              },
            },
          },
        },
      };

      const subscriptionData = subscription.checked
        ? {
            data: {
              type: "subscription",
              attributes: {
                profile: {
                  data: {
                    type: "profile",
                    attributes: { email },
                  },
                },
              },
              relationships: {
                list: {
                  data: {
                    type: "list",
                    id: KLAVIYO_LIST_ID,
                  },
                },
              },
            },
          }
        : null;

      const fetchPromises = [
        fetch(backInStockUrl, fetchOptions(backInStockData)),
      ];

      if (subscriptionData) {
        fetchPromises.push(
          fetch(subscriptionUrl, fetchOptions(subscriptionData)),
        );
      }

      Promise.all(fetchPromises)
        .then((responses) => {
          const allSuccessful = responses.every((response) => response.ok);
          if (allSuccessful) {
            this.successMessage();
          } else {
            this.errorMessage();
          }
        })
        .catch((error) => {
          this.errorMessage();
          throw new Error(error);
        });
    }
  },
);
